export const CopyCheckIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_23849_23082)">
        <path
          d="M14 6.66675C14 6.29856 13.7015 6.00008 13.3334 6.00008H6.66669C6.2985 6.00008 6.00002 6.29856 6.00002 6.66675V13.3334C6.00002 13.7016 6.2985 14.0001 6.66669 14.0001H13.3334C13.7015 14.0001 14 13.7016 14 13.3334V6.66675ZM11.5287 8.19539C11.789 7.93504 12.211 7.93504 12.4714 8.19539C12.7317 8.45574 12.7317 8.87775 12.4714 9.1381L9.80471 11.8048C9.54436 12.0651 9.12235 12.0651 8.862 11.8048L7.52867 10.4714L7.48309 10.4207C7.26953 10.1588 7.28459 9.7728 7.52867 9.52873C7.77274 9.28465 8.15874 9.26959 8.42059 9.48315L8.47137 9.52873L9.33335 10.3907L11.5287 8.19539ZM10 2.66675C10 2.3016 9.6985 2.00008 9.33335 2.00008H2.66669C2.30154 2.00008 2.00002 2.3016 2.00002 2.66675V9.33341C2.00002 9.69856 2.30154 10.0001 2.66669 10.0001C3.03488 10.0001 3.33335 10.2986 3.33335 10.6667C3.33335 11.0349 3.03488 11.3334 2.66669 11.3334C1.56516 11.3334 0.666687 10.4349 0.666687 9.33341V2.66675C0.666687 1.56522 1.56516 0.666748 2.66669 0.666748H9.33335C10.4349 0.666748 11.3334 1.56522 11.3334 2.66675C11.3334 3.03494 11.0349 3.33341 10.6667 3.33341C10.2985 3.33341 10 3.03494 10 2.66675ZM15.3334 13.3334C15.3334 14.438 14.4379 15.3334 13.3334 15.3334H6.66669C5.56212 15.3334 4.66669 14.438 4.66669 13.3334V6.66675C4.66669 5.56218 5.56212 4.66675 6.66669 4.66675H13.3334C14.4379 4.66675 15.3334 5.56218 15.3334 6.66675V13.3334Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_23849_23082">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
